"use client";

import CodeTableCloud from "@/components/code-table/CodeTableCloud";
import CodeTableLocal from "@/components/code-table/CodeTableLocal";
import AppLayout from "@/components/layout/AppLayout";
import TranslationsProvider from "@/components/TranslationsProvider";
import { EduRoboShopAd } from "@/components/edu-robo-shop";
import { FundingAcknowledgment } from "@/components/funding";
import EventCards, { EVENT_CARDS_HEIGHT } from "@/components/events/EventCards";
import { useAuth } from "@/context/AuthContext";
import { Col, Row } from "antd";
import React from "react";

const i18nNamespaces = ["common"];

export default function Home({ params }: PageProps<"/[locale]">) {
    const { locale } = React.use(params);
    const { isLoggedIn } = useAuth();

    const customHeaders = <>{/* <div style={{ flexGrow: 20 }}></div> */}</>;

    // The competition cards sit above the code tables; the tables size their
    // scroll area from this variable.
    const topStripHeight = isLoggedIn ? EVENT_CARDS_HEIGHT : 0;

    return (
        <TranslationsProvider locale={locale} namespaces={i18nNamespaces}>
            {/* The cards replace the event banner here, so the page keeps its height */}
            <AppLayout headerContent={customHeaders} showEventBanner={false}>
                <Row
                    gutter={8}
                    style={
                        {
                            height: "calc(100vh - 74px)",
                            margin: "0px 3px",
                            "--home-top-strip": `${topStripHeight}px`,
                        } as React.CSSProperties
                    }
                >
                    <Col
                        span={20}
                        style={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <EventCards />
                        <Row gutter={8} style={{ flex: 1, minHeight: 0 }}>
                            <Col
                                span={12}
                                style={{ height: "100%", overflow: "none" }}
                            >
                                <CodeTableLocal />
                            </Col>
                            <Col
                                span={12}
                                style={{ height: "100%", overflow: "none" }}
                            >
                                <CodeTableCloud />
                            </Col>
                        </Row>
                    </Col>
                    <Col
                        span={4}
                        style={{
                            height: "100%",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                        }}
                    >
                        <EduRoboShopAd />
                        <FundingAcknowledgment />
                    </Col>
                </Row>
            </AppLayout>
        </TranslationsProvider>
    );
}
